import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { FormBuilder, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { AuthService } from '../auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  public user$: Observable <any> = this._auth._authfb.user;
  
  forma;

  constructor(
    private fb: FormBuilder,
    private _auth: AuthService,
    private router: Router
  ) { }

  loading(){
    Swal.fire({
      title: 'Cargando',
      text: 'Espere por favor...',
      icon: 'info',
      allowOutsideClick: false,
      onBeforeOpen: () => {
        Swal.showLoading();
      }
    });
  }

  ngOnInit(): void {
    this.detectaSesionActual();
    this.forma = this.fb.group({
      email: this.fb.control("", [Validators.required, Validators.email]),
      password: this.fb.control("", [Validators.required, Validators.minLength(5)])
    });
  }

    //Detecta una sesión activa y la inicia
    detectaSesionActual(){
      this.user$.subscribe(data => {
        // Verifica si ya tiene sus datos de usuario
        if(data?.email){
          this.router.navigate(['/menu']);
        }
      });
    }

  test(){
    console.log(this.forma);
  }

  async login(){
    const {email, password} = this.forma.value;

    try {
      // Forzado a correos del tipo 'usuario@app_domain.com'
      const result = await this._auth.login(email, password);

      if(result?.code){
        console.error("Error al iniciar sesion:", result?.message);

        Swal.fire({
          title: "Datos Incorrectos",
          text: "Los datos proporcionados son incorrectos.", 
          icon: 'error'
        }); 
        console.error({error: result.code})
      }else{
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Inicio de sesión correcto',
          showConfirmButton: false,
          timer: 1500
        });


/*         this._auth._authfb.onAuthStateChanged( async user => {
          if(!user){
            console.log({user})
          }
        }); */

        this.router.navigate(['/menu']);
      }

    } catch (error) {
      if(error){
        console.error({error});
        return 0;
      }
    }
  }

}
